



exports.createAuthSystem = ({$scope,sendMessageSystem})=>{
    return {
        handleRequestAuthToken: ()=>
        sendMessageSystem.send('mi.provideAuthToken',
            {
                authToken: $scope.context.API_TOKEN,
                csrfToken: $scope.context.CSRF_TOKEN,
                isStaff:$scope.context.is_staff
                // cookie:document.cookie //not very tasty
            })
    }
}



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/search-panel/authSystem.js